import React, { useEffect, useState } from "react";
import TypePersonSelect from "../Select/TypePersonSelect";
import InputPfPj from "../InputText/InputPfPj";
import InputIeRg from "../InputText/InputIeRg";
import CellPhone from "../InputText/CellPhone";

interface props {
  customerData: any;
  setCustomerData: any;
  isInvalid?: any;
  setIsInvalid?: any;
  setShowModal: any;
  disableCnpj: any;
  idCnpj?: any;
}

const CustomerData: React.FC<props> = ({ customerData, setCustomerData, isInvalid, setIsInvalid, setShowModal, disableCnpj,idCnpj }) => {
  const [nomeRazao, setNomeRazao] = useState({
    name: '',
    nickName: '',
    placeName: '',
    placeNick: '',
    invalidName: '',
    invalidNickName: ''
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { id, value } = event.target;
    setCustomerData((prevForm: any) => ({
      ...prevForm,
      [id]: value,
    }));

    setIsInvalid((prevForm: any) => ({
      ...prevForm,
      [id]: false,
    }));
    console.log(customerData)
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target
    if (id === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setIsInvalid((prevForm: any) => ({
          ...prevForm,
          [id]: true,
        }));
        return;
      }
    }

    if (value.length == 0) {
      setIsInvalid((prevForm: any) => ({
        ...prevForm,
        [id]: true,
      }));
    }
  }

  useEffect(() => {
    switch (customerData.pfpj) {
      case "FÍSICA":
        setNomeRazao({
          name: "Nome", nickName: 'Sobrenome',
          placeName: 'Nome', placeNick: 'Sobrenome',
          invalidName: 'Insira um Nome',
          invalidNickName: 'Insira um Sobrenome',
        })
        break;
      case "JURÍDICA":
        setNomeRazao({
          name: "Razão Social", nickName: 'Nome Fantasia',
          placeName: 'Razão Social', placeNick: 'Nome Fantasia',
          invalidName: 'Insira uma Razão',
          invalidNickName: 'Insira um Nome Fantasia',
        })
        break;
      case "stranger":
        setNomeRazao({
          name: "Nome", nickName: 'Sobrenome',
          placeName: 'Nome', placeNick: 'Sobrenome',
          invalidName: 'Insira um Nome',
          invalidNickName: 'Insira um Sobrenome',
        })
        break;
    }
  }, [customerData.pfpj])

  return (
    <div className="container-fluid pb-4 pt-0">
      <div className="row">
        <TypePersonSelect
          id="pfpj"
          idCnpj={idCnpj}
          value={customerData?.pfpj}
          setCustomerData={setCustomerData}
        />
        <InputPfPj
          id={customerData?.pfpj}
          value={customerData?.cnpj}
          className={`form-control ${isInvalid.cnpj ? 'is-invalid' : ''}`}
          setCustomerData={setCustomerData}
          setIsInvalid={setIsInvalid}
          setShowModal={setShowModal}
          disable={disableCnpj}
        />
        <InputIeRg
          IeRg={customerData.pfpj}
          idCnpj={idCnpj}
          handleChange={handleChange}
          handleBlur={handleBlur}
          setCustomerData={setCustomerData}
          setIsInvalid={setIsInvalid}
          value={customerData?.ierg}
          className={`form-control ${isInvalid.ierg ? 'is-invalid' : ''}`}
        />
        <div className="col-md-6 col-lg-4">
          <label>{nomeRazao.name}</label>
          <input
            id="razao"
            className={`form-control ${isInvalid.razao ? 'is-invalid' : ''}`}
            type="text"
            value={customerData?.razao}
            placeholder={nomeRazao.placeName}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={idCnpj ? true : false}
          />
          <p className="invalid-feedback">{nomeRazao.invalidName}</p>
        </div>
        <div className="col-md-6 col-lg-4">
          <label>{nomeRazao.nickName}</label>
          <input
            id="nome_fantasia"
            className={`form-control ${isInvalid.nome_fantasia ? 'is-invalid' : ''}`}
            type="text"
            value={customerData?.nomeFantasia}
            placeholder={nomeRazao.placeNick}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={idCnpj ? true : false}
          />
          <p className="invalid-feedback">{nomeRazao.invalidNickName}</p>
        </div>
        <div className="col-md-6 col-lg-4">
          <CellPhone
            id="telefone"
            idCnpj={idCnpj}
            label="Telefone"
            value={customerData?.telefone}
            setIsInvalid={setIsInvalid}
            className={`form-control ${isInvalid.telefone ? 'is-invalid' : ''}`}
            setCustomerData={setCustomerData}
          />
        </div>
        <div className="col-md-6 col-lg-4">
          <CellPhone
            id="celular"
            idCnpj={idCnpj}
            label="Celular"
            value={customerData?.celular}
            setIsInvalid={setIsInvalid}
            className={`form-control ${isInvalid.celular ? 'is-invalid' : ''}`}
            setCustomerData={setCustomerData}
          />
        </div>
        <div className="col-md-6 col-lg-4">
          <label>Email</label>
          <input
            id="email"
            className={`form-control ${isInvalid.email ? 'is-invalid' : ''}`}
            type="email"
            value={customerData?.email}
            placeholder="email@dominio.com"
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={idCnpj ? true : false}
          />
          <p className="invalid-feedback">Insira no Fomato texto@dominio.com</p>
        </div>
        <div className="col-md-6 col-lg-4">
          <label>Status</label>
          <select
            id="status"
            className={`form-control ${isInvalid.status ? 'is-invalid' : ''}`}
            value={customerData?.status}
            onChange={handleChange}
            disabled={idCnpj ? true : false}
          >
            <option value="0">0</option>
            <option value="1">1</option>
          </select>
          <p className="invalid-feedback"></p>
        </div>
      </div>
    </div>
  )
}

export default CustomerData